export const SELECT_MOLECULE_SIDE_MENU = 'SELECT_MOLECULE_SIDE_MENU';
export const DISPLAY_MOLECULE = 'DISPLAY_MOLECULE';
export const TOGGLE_SPECTRUM = 'TOGGLE_SPECTRUM';
export const SET_IS_PAUSED = 'SET_IS_PAUSED';
export const SET_MOLECULE_AREA_STATUS = 'SET_MOLECULE_AREA_STATUS';
export const CLEAR_MOLECULE_AREA = 'CLEAR_MOLECULE_AREA';
export const RESET_ALL_MOLECULE_AREAS = 'RESET_ALL_MOLECULE_AREAS';
export const TOGGLE_SHOW_ELECTRIC_FIELD_VECTOR =
  'TOGGLE_SHOW_ELECTRIC_FIELD_VECTOR';
export const TOGGLE_SHOW_ATOMS_CHARGES = 'TOGGLE_SHOW_ATOMS_CHARGES';
export const TOGGLE_SHOW_RE_EMISSION = 'TOGGLE_SHOW_RE_EMISSION';
export const HIGHLIGHT_ALL_SIDE_MENU_MOLECULES =
  'HIGHLIGHT_ALL_SIDE_MENU_MOLECULES';
export const RESET_ALL_SETTINGS = 'RESET_ALL_SETTINGS';
export const INCREMENT_INTERVAL_COUNT = 'INCREMENT_INTERVAL_COUNT';
export const DECREMENT_INTERVAL_COUNT = 'DECREMENT_INTERVAL_COUNT';
export const RESET_INTERVAL_COUNT = 'RESET_INTERVAL_COUNT';
export const BEGIN_RE_EMISSION_INTERVAL_COUNT =
  'BEGIN_RE_EMISSION_INTERVAL_COUNT';
